import LigthBox from "../components/Lightbox";

export default class PageSingleServizio {
  constructor() {
    this.data;
    this.lightbox = new LigthBox();
  }

  init(data) {
    this.data = data;
    this.init_swiper_title_galleries();
  }

  init_swiper_title_galleries() {
    const galleries = document.querySelectorAll(".js-swiper-title-gallery");
    galleries?.forEach((gallery) => {
      const swiper = new Swiper(gallery, {
        slidesPerView: "auto",
        spaceBetween: 10,
        freeMode: true,
        breakpoints: {
          768: {
            spaceBetween: 20,
          },
        },
      });
    });
  }
}
